import React from 'react'
import {  Grid } from "@mui/material";
import CustomDateTimePicker from "../../../shared/CustomDateTimePicker";
import CustomButton from "../../../shared/CustomButton";

const NotificationFilters = ({formik}) => {
    return (
        <Grid
          container
          justifyContent="flex-start"
          alignItems="start"
          gap="20px"
          sx={{ 
            padding: "20px 20px 25px 20px",
            
    borderBottom: "1px solid #E7E9EF",
    background: "#fff",
         }}
        >
          <Grid item>
           
            <CustomDateTimePicker
              width={230}
              inputwidth={230}
              label="Start Date/Time"
              name="dateFrom"
             dateValue={formik.values.dateFrom}
             formik={formik}
            />
          
              
           
          </Grid>
  
          <Grid>
          <CustomDateTimePicker
              width={230}
              inputwidth={230}
              label="End Date/Time"
              name="dateTo"
             dateValue={formik.values.dateTo}
             formik={formik}
            />
             
          </Grid>
         
  
  
          <Grid>
         
                <CustomButton
                  text="Show Notifications"
                  processing={false}
                  disabled={false}
                  action={formik.handleSubmit}
                />
          </Grid>
        </Grid>
     
        
     
    );
}

export default NotificationFilters